// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1fIgg","title":"ClientReferral_title__srEbV","itemText":"ClientReferral_itemText__MCvuF"};